var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "wa-modal-fade" } }, [
        _vm.visible
          ? _c(
              "div",
              {
                staticClass: "wa-modal-overlay",
                on: { click: _vm.handleOverlayClick },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "wa-modal-container",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "wa-modal-close",
                        on: { click: _vm.handleCancel },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("close"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "wa-modal-wrapper" }, [
                      _c("div", { staticClass: "wa-modal-header" }, [
                        _c("h2", [_vm._v("WhatsApp Entegrasyonu")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "İşletmenize en uygun WhatsApp çözümünü seçin"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "wa-modal-body" }, [
                        _c("div", { staticClass: "wa-solutions-grid" }, [
                          _c(
                            "div",
                            { staticClass: "wa-solution-card wa-v2-card" },
                            [
                              _c("div", { staticClass: "wa-card-icon" }, [
                                _c(
                                  "div",
                                  { staticClass: "wa-icon-circle whatsapp-bg" },
                                  [
                                    _c("WhatsappV2Icon", {
                                      attrs: { color: "#fff" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "wa-card-content" }, [
                                _c("h3", [_vm._v("WhatsApp V2")]),
                                _vm._v(" "),
                                _c("p", { staticClass: "wa-card-subtitle" }, [
                                  _vm._v("QR Kod ile Hızlı Başlangıç"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "wa-features-section" },
                                  [
                                    _c("div", { staticClass: "wa-pros" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-check" },
                                          [_vm._v("✓")]
                                        ),
                                        _vm._v(" Avantajlar"),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v("Dakikalar içinde kurulum"),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v("Ekstra belge gerektirmez"),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            "Temel mesajlaşma özellikleri"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [_vm._v("Grup desteği")]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "wa-cons" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-cross" },
                                          [_vm._v("✕")]
                                        ),
                                        _vm._v(" Sınırlamalar"),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [_vm._v("Cihaz bağımlı")]),
                                        _vm._v(" "),
                                        _c("li", [_vm._v("Düşük SLA")]),
                                        _vm._v(" "),
                                        _c("li", [_vm._v("Ban riski var")]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "wa-solution-card wa-v3-card" },
                            [
                              _c("div", { staticClass: "wa-card-icon" }, [
                                _c(
                                  "div",
                                  { staticClass: "wa-icon-circle whatsapp-bg" },
                                  [
                                    _c("WhatsappV3Icon", {
                                      attrs: { color: "#fff" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "wa-card-content" }, [
                                _c("h3", [_vm._v("WhatsApp V3")]),
                                _vm._v(" "),
                                _c("p", { staticClass: "wa-card-subtitle" }, [
                                  _vm._v("Gelişmiş Özellikler"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "wa-features-section" },
                                  [
                                    _c("div", { staticClass: "wa-pros" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-check" },
                                          [_vm._v("✓")]
                                        ),
                                        _vm._v(" Avantajlar"),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v("V2'nin tüm özellikleri"),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [_vm._v("Mesaj alıntılama")]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v("Newsletter kanalları"),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v("Profil fotoğrafı alma"),
                                        ]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "wa-cons" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-cross" },
                                          [_vm._v("✕")]
                                        ),
                                        _vm._v(" Sınırlamalar"),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [_vm._v("Cihaz bazlı")]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v("Ban riski devam eder"),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [_vm._v("Düşük SLA")]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "wa-solution-card wa-api-card" },
                            [
                              _c("div", { staticClass: "wa-card-icon" }, [
                                _c(
                                  "div",
                                  { staticClass: "wa-icon-circle whatsapp-bg" },
                                  [
                                    _c("WhatsappBusinessIcon", {
                                      attrs: { color: "#fff" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "wa-card-content" }, [
                                _c("h3", [_vm._v("WhatsApp API")]),
                                _vm._v(" "),
                                _c("p", { staticClass: "wa-card-subtitle" }, [
                                  _vm._v("Kurumsal Çözüm"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "wa-features-section" },
                                  [
                                    _c("div", { staticClass: "wa-pros" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-check" },
                                          [_vm._v("✓")]
                                        ),
                                        _vm._v(" Avantajlar"),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v("Meta onaylı resmi çözüm"),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v("%99.9 SLA garantisi"),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [_vm._v("REST API desteği")]),
                                        _vm._v(" "),
                                        _c("li", [_vm._v("Şablon mesajlar")]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "wa-cons" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-cross" },
                                          [_vm._v("✕")]
                                        ),
                                        _vm._v(" Sınırlamalar"),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v("Uzun kurulum süreci"),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [_vm._v("Mesaj ücreti var")]),
                                        _vm._v(" "),
                                        _c("li", [_vm._v("Belge gerekli")]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "wa-info-banner" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("info"),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [_vm._v("Bağlantı Stabilitesi:")]),
                            _vm._v(
                              " V2 ve V3 çözümleri nadiren bağlantı kesintisi yaşayabilir.\n                            Kritik operasyonlar için WABA API önerilir.\n                        "
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "wa-modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "wa-btn wa-btn-link",
                            on: { click: _vm.handleDetailedComparison },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("compare_arrows"),
                            ]),
                            _vm._v(
                              "\n                        Detaylı Karşılaştırma\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "wa-footer-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass: "wa-btn wa-btn-secondary",
                              on: { click: _vm.handleCancel },
                            },
                            [
                              _vm._v(
                                "\n                            İptal\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "wa-btn wa-btn-primary",
                              on: { click: _vm.handleAccept },
                            },
                            [
                              _vm._v(
                                "\n                            Onayla ve devam et\n                        "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "wa-modal-fade" } }, [
        _vm.showDetailedModal
          ? _c(
              "div",
              {
                staticClass: "wa-detailed-modal-overlay",
                on: { click: _vm.closeDetailedModal },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "wa-detailed-modal-container",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "wa-modal-close",
                        on: { click: _vm.closeDetailedModal },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("close"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("WhatsappComparison"),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }